// src/store/authActions.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import authServiceApiInstance from '../../../config/apiConfig'; // Import the configured axios instance
import { SignInResponse, SignInCredentials } from './authTypes';
import operationServiceApiInstance from '../../../config/openApionfig';

// SignIn action

export const signIn = createAsyncThunk<SignInResponse, SignInCredentials, { rejectValue: string }>(
  'auth/signIn',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await operationServiceApiInstance.post('/auth/login', credentials);
      const { data } = response.data;
      return {
        status: 'success',
        message: 'OK',
        data: {
          ...data,
        },
      };
    } catch (error: any) {
      if (error.response && error.response.data) {
        // Check for the custom error message from server
        return rejectWithValue(error.response.data.error || 'Something went wrong');
      }
    
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }
    
      return rejectWithValue('Something went wrong');
    }
  }
);
// Forgot password action
export const forgotPassword = createAsyncThunk(
  'auth/forgotPassword',
  async (
    { email, subscription_id,configID }: { email: string; subscription_id: string ,configID:any},
    { rejectWithValue }
  ) => {
    try {
      const response = await operationServiceApiInstance.post('/auth/forgot-password', {
        email,
        subscription_id,
        configID
      });
      return response.data;
    } catch (error: unknown) {
      if (error instanceof Error && (error as any).response) {
        const errorResponse = (error as any).response.data;
        if (errorResponse.error) {
          return rejectWithValue(errorResponse.error);
        }
        return rejectWithValue(errorResponse.message || 'Something went wrong');
      }
      return rejectWithValue('Something went wrong');
    }
  }
);



// Reset password action
export const resetPassword = createAsyncThunk(
  'auth/reset-password',
  async (payload: { email: string; otp: string; newPassword: string }, { rejectWithValue }) => {
    try {
      const response = await operationServiceApiInstance.post('/auth/reset-password', payload);
      return response.data;
    } catch (error: unknown) {
      if (error instanceof Error && (error as any).response) {
        const errorResponse = (error as any).response.data;
        if (errorResponse.error) {
          return rejectWithValue(errorResponse.error);
        }
        return rejectWithValue(errorResponse.message || 'Something went wrong');
      }
      return rejectWithValue('Something went wrong');
    }
  }
);


// Resend OTP action
export const resendOtp = createAsyncThunk('auth/resendOtp', async (email: string, { rejectWithValue }) => {
  try {
    const response = await operationServiceApiInstance.post('/auth/resend-otp', { email });
    return response.data.message;
  } catch (error: unknown) {
    if (error instanceof Error) {
      return rejectWithValue(error.message || 'Something went wrong');
    }
    return rejectWithValue('Something went wrong');
  }
});

export const logout = createAsyncThunk('auth/logout', async (email: string, { rejectWithValue }) => {
  try {
    // Call the backend logout API to remove the session
    const response = await authServiceApiInstance.post('/auth/logout', { email });
    return response.data.message; // Return the success message from the API
  } catch (error: unknown) {
    if (error instanceof Error) {
      return rejectWithValue(error.message || 'Something went wrong');
    }
    return rejectWithValue('Something went wrong');
  }
});

// src/store/authActions.ts
export const verifyActiveSession = createAsyncThunk<
  { active: boolean; message: string },
  { session_id: string },
  { rejectValue: string }
>(
  'auth/verifyActiveSession',
  async ({ session_id }, { rejectWithValue }) => {
    try {
      const response = await authServiceApiInstance.post('/auth/verify-active-session', { session_id });
      return response.data; // { active: true/false, message: string }
    } catch (error: any) {
      if (error.response?.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue('Failed to verify session');
    }
  }
);
